export default function getTimeSlotSpan(slotSize: number): number {
  switch (slotSize) {
    case 15:
    case 60:
      return 3;
    case 30:
      return 6;
    default:
      return 12;
  }
}
